<template>
    <div>
        <v-tabs
            v-model="tab"
            background-color="white"
            color="primary"
            slider-color="primary"
            centered
            grow
        >
            <v-tab
                v-for="page, index in ['Fichajes', 'Localización']"
                :key="index"
                :value="index"
                ripple
            >
                {{ page }}
            </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
            <v-tab-item
                key="0"
            >
                <PunchInView/>
            </v-tab-item>
            <v-tab-item key="1">
                <PunchInGeo/>
            </v-tab-item>
        </v-tabs-items>
        <DeleteDialog/>
        <PunchIntoComplete/>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'


import PunchIntoComplete from './PunchInToComplete.vue'
import PunchInGeo from './PunchInGeo.vue';
import PunchInView from './PunchInView.vue';
import DeleteDialog from '@/components/DeleteDialog/DeleteDialog.vue';
export default {
    name: 'PunchInBase',
    data: () => ({
        tab: '0',
        offer: null,
        parentRenderMutation: null,

        estadoComercial: {
            ALTA: 'success',
            BAJA: 'warning',
            INACTIVO: 'error',
            VACACIONES: 'blue',
        },
    }),
    components: {
        DeleteDialog,
        PunchIntoComplete,
        PunchInView,
        PunchInGeo,
    },
    methods: {
        ...mapActions('punchIn', ['fetchPunches']),
    },
    beforeMount(){
        this.fetchPunches()
        if (this.$store.state.teletrabajo.Comerciales.length === 0 && !this.hasComercialPermission) {
            this.$store.dispatch('teletrabajo/fetchComerciales')
        }
    }
}
</script>
